import { render, staticRenderFns } from "./ViewCollapsePanel.vue?vue&type=template&id=f85a58e6&scoped=true&"
import script from "./ViewCollapsePanel.vue?vue&type=script&lang=js&"
export * from "./ViewCollapsePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85a58e6",
  null
  
)

export default component.exports